import _ from '/home/ps/root'
import View from './view' // empty place holder for static methods

export default class Part extends View {
  // static onChange = (that, selected, ref = window.location.pathname) => {
  static onChange = (that, selected) => {debugger
    that.setState({selected})
    // window[_.REF] = window.location.pathname
    that.props.action.part(selected)
  }
  static onClick = (that, e, p = that.props) => {debugger
    e.stopPropagation()
    p.action.slide()
  }
  static init = (p, id, v='master') => {debugger
    const pv = p.init[v]
    return id && pv ? pv.response[id] : pv ? pv.response : {}
  }
}
